export async function getShiftSessionId(): Promise<string | undefined> {
    return new Promise((resolve) => {
        let attempts = 0;
        const intervalID = setInterval(() => {
            if (attempts >= 5) {
                resolve(undefined);
                clearInterval(intervalID);
            }
            if (typeof window.sd === "function") {
                try {
                    // @ts-ignore
                    window.sd("getSessionId", (sessionId) => {
                        if (typeof sessionId === "string") {
                            resolve(sessionId);
                            clearInterval(intervalID);
                        }
                    });
                    attempts++;
                } catch (e) {
                    attempts++;
                }
            } else {
                attempts++;
            }
        }, 2000);
    });
}
